import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import ModalAttachments from "src/components/ModalAttachments";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { convertIFileDTOArrayToFileArray } from "src/Interfaces/fileDTO";
import { standardErrorMessages } from "src/utils/errors";
import IDiagnosticAttachmentsRef from "./interface";

const AttachmentsModal: React.ForwardRefRenderFunction<IDiagnosticAttachmentsRef> = (_, ref) => {
	const { translate } = useTranslation();
	const { setLoading } = useLoaderBackdrop();
	const { addToast } = RCCHookToast();

	const modalAttachment = useRef<RCCRefModalProps>(null);
	const [comparativeId, setComparativeId] = useState(0);
	const [disabled, setDisabled] = useState(false);
	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
	const [attachments, setAttachments] = useState<File[]>([]);
	const onCallbackAttachments = useRef<Function | undefined>(undefined);

	const openModalComparativeAttachments = async (id: number, titleComparative: string, onCallback?: Function, disabledX?: boolean) => {
		setDisabled(disabledX ?? false);
		try{
			setLoading(true);

			const {data} = await RCCServicesApi.getRequest({
				method: "Diagnostics/SelectAttachments",
				urlParameters: {
					id
				}
			});
			let dataFormatted: File[] = [];

			if(data && data.length > 0)
				dataFormatted = convertIFileDTOArrayToFileArray(data);

			setAttachments(dataFormatted);
			onCallbackAttachments.current = onCallback;
			setLoading(false);
			setComparativeId(id);
			setSubtitle(`${translate("Comparativo")}: ${titleComparative}`);
			modalAttachment.current?.openModal();
		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar anexos"), addToast);
		}
	};

	const onAddAttachment = async (data: any) => {
		try{
			setLoading(true);
			const formData = new FormData();
			formData.append("ComparativeId", comparativeId.toString());
			data.attachments.forEach((attach: any, index: number) => {
				formData.append(`Attachments[${index}]`, attach);
			});

			await RCCServicesApi.postRequest({
				method: "Diagnostics/InsertAttachments",
				contentType: "multipart/form-data",
				body: formData
			});

			addToast({
				title: translate("Sucesso"),
				description: translate("Anexos salvos com sucesso"),
				color: "green"
			});

			modalAttachment.current?.closeModal();

			if(onCallbackAttachments.current)
				onCallbackAttachments.current();
				
			setLoading(false);

		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao adicionar anexos"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalComparativeAttachments
	}));

	return (
		<>
			
			<ModalAttachments 
				ref={modalAttachment}
				subtitle={subtitle}
				filesInit={attachments}
				name="attachments"
				onSubmit={onAddAttachment}
				onCallbackAttachments={onCallbackAttachments.current}
				disabled={disabled}
			/>
		</>
	);
};

export default forwardRef(AttachmentsModal);
